"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const note_repository_1 = require("./note.repository");
let NoteService = class NoteService {
    constructor(noteRepository, dataSource) {
        this.noteRepository = noteRepository;
        this.dataSource = dataSource;
    }
    // Create a new note
    async createNote(noteData, entityManager) {
        try {
            const createNote = async (manager) => {
                const { documents, ...noteDetails } = noteData;
                const note = await this.noteRepository.createNote(noteDetails, manager);
                if (documents && documents.length > 0) {
                    await this.noteRepository.createNoteDocuments(documents, note.id, manager);
                }
                return { id: note.id };
            };
            if (entityManager) {
                return await createNote(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(createNote); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Get notes with pagination, search, and sorting
    async getNotes(page, limit, search, sort, userId, searchBy) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search);
            const sortParams = (0, helper_utils_1.mapSortParams)(sort);
            const notes = await this.noteRepository.getNotes(page, limit, searchParams, sortParams, userId, searchBy);
            return notes;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new Error(messages_1.errorMessages.noteListRetrievalFailed);
        }
    }
    // Get a note by ID
    async getNoteById(id) {
        try {
            const note = await this.noteRepository.getNoteById(id);
            if (!note) {
                throw new common_1.NotFoundException(messages_1.errorMessages.noteNotFound);
            }
            return note;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Update a note by ID
    async updateNoteById(id, updateNoteData, entityManager) {
        try {
            const updateNote = async (manager) => {
                const { documents, ...noteDetails } = updateNoteData;
                await this.noteRepository.updateNote(id, noteDetails, manager);
                if (documents && documents.length > 0) {
                    await this.noteRepository.updateNoteDocuments(documents, id, manager);
                }
                return { id };
            };
            if (entityManager) {
                return await updateNote(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(updateNote); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Delete a note by ID
    async deleteNoteById(id) {
        try {
            await this.noteRepository.deleteNoteById(id);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
};
exports.NoteService = NoteService;
exports.NoteService = NoteService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof note_repository_1.NoteRepository !== "undefined" && note_repository_1.NoteRepository) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _b : Object])
], NoteService);
